import Logo from '@ergeon/core-components/exports/Logo.ts';

import LobbyTitle from '@/app/pages/LobbyPage/LobbyTitle';
import type { SettledMeetingCopy } from '@/app/queries/MeetingContextQuery/useMeetingCopy';

interface LobbyHeaderProps {
  copy: Pick<SettledMeetingCopy, 'title' | 'isSettled'>;
  isClient: boolean;
  startTime: string;
  customerName?: string;
  staffName?: string;
}

export default function LobbyHeader({
  copy, customerName, isClient, staffName, startTime,
}: LobbyHeaderProps) {
  const meetingWith = isClient ? staffName : customerName;

  return (
    <header className="flex flex-col gap-6">
      {/* Without this the flex row stretches the SVG to the column and
          the wordmark centres itself inside its own viewBox. */}
      <Logo className="self-start w-auto shrink-0" size="medium" />
      <div className="flex flex-col gap-1">
        <LobbyTitle isSettled={copy.isSettled} title={copy.title} />
        {startTime && <p className="paragraph-1">{startTime}</p>}
        {meetingWith && <p className="paragraph-2 text-gray-500 dark:text-gray-400">with {meetingWith}</p>}
      </div>
    </header>
  );
}
